import React, { Component } from "react"

/* Icons */
import { LoadingOutlined } from '@ant-design/icons'


/* Component Layout */
class Layout extends Component {

    /* Draw button */
    _button = () => {

        /* Fields */
        const { reload, add, refresh } = this.props

        /* Draw Reload Button */
        if (reload) {
            return <div onClick={() => reload()} className="button">Повторить</div>
        }

        /* Draw Reload Button */
        if (refresh) {
            return <div onClick={() => refresh()} className="button">Перезагрузить</div>
        }

        /* Draw Reload Button */
        if (add) {
            return <div onClick={() => add()} className="button">Добавить</div>
        }
    }

    render = () => {

        /* Fields */
        const { status, type, connection, mode } = this.props

        /* Socket */
        if (status === "socket") {

            if (connection === "new-tab") {
                return (
                    <div className={`layout-box ${mode}`}>
                        <img src="/images/new-tab.png" alt="New Tab" />
                        <h2>Вы вошли с новой вкладки!</h2>
                        <p>Чтобы заново войти, перезагрузите страницу!</p>
                        {this._button()}
                    </div>
                )
            }

            if (connection === "disconnected") {
                return (
                    <div className={`layout-box ${mode}`}>
                        <img src="/images/alert.png" alt="Alert" />
                        <h2>Нет соединения с Socket!</h2>
                        <p>Что-то пошло не так! Попробуйте позднее.</p>
                        {this._button()}
                    </div>
                )
            }

            if (connection === "loading") {
                return (
                    <div className={`layout-box ${mode}`}>
                        <LoadingOutlined />
                        <p>Соединение :::</p>
                    </div>
                )
            }

        }

        if (status === "empty") {
            if (type === "user") {
                return (
                    <div className={`layout-box ${mode}`}>
                        <img src="/images/empty.png" alt="Empty" style={{ filter: "invert(0)" }} />
                        <h2>Пользователей не найдено</h2>
                        <p>Добавьте пользователя</p>
                        {this._button()}
                    </div>
                )
            }
        }

        if (status === "error") {
            return (
                <div className={`layout-box ${mode}`}>
                    <img src="/images/alert.png" alt="Alert" />
                    <h2>Ошибка сервера!</h2>
                    <p>Что-то пошло не так! Попробуйте позднее.</p>
                    {this._button()}
                </div>
            )
        }

        if (status === "network") {
            return (
                <div className={`layout-box ${mode}`}>
                    <img src="/images/wifi.png" alt="Wifi" />
                    <h2>Ошибка соединения!</h2>
                    <p>Проверьте подключение к сети.</p>
                    {this._button()}
                </div>
            )
        }

        return (
            <div className={`layout-box ${mode}`}>
                <LoadingOutlined />
                <p>Загрузка :::</p>
            </div>
        )
    }

}

export default Layout